<template>
  <div data-testid="checkout-div-171" class="opc-pbx__change-cycle" v-html="$t('billing.pbx.contact_us_if_you_like_change',[cycle, payment, contactSalesLink])" @click='handleClick($event)'></div>
</template>

<script>
import { getPbxContactSalesLink } from '@/utils/i18n-shortcuts';

export default {
  props: {
    cycle: String,
    payment: String
  },
  data() {
    return {
      contactSalesLink: getPbxContactSalesLink(),
    }
  },
  methods: {
    capitalize(str){
      const chars = str.split('');
      return `${chars[0].toUpperCase()}${chars.slice(1).join('')}`;
    },
    handleClick(e) {
      this.$emit('click', e);
    }
  },
}
</script>

<style lang="scss">
.opc-pbx__change-cycle {
  font-style: normal;
  font-weight: 450;
  font-size: 14px;
  line-height: 150%;
  color: #666487;
  margin-top: 8px;
  b {
    text-transform: lowercase;
    color: #00031F;
  }
}

</style>
